import '../../css/base.css';

const Access = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Access</h2>
      <p className="your-stay-text">Check-in as after 3pm on the Friday.  Key safe at rear of cottage by back door <strong>(code 1980)</strong>.  Please ensure you return the keys to the key safe 
                                    on your departure.
      </p>
    </div>
  );
}

export default Access;